import { isFilmAvailableForAdvanceBookings } from '@vista/omnichannel-components-domain';
import { FilmCategory } from '@vista-digital/ocapi-types/v1';
export const getFilmStatusLabel = (filmAvailability, displayText) => {
    const { categories, filmId, siteId } = filmAvailability;
    if (categories.includes(FilmCategory.NowShowing))
        return displayText.nowShowingLabel;
    if (isFilmAvailableForAdvanceBookings(filmId, siteId))
        return displayText.preBookNowLabel;
    if (categories.includes(FilmCategory.AdvanceBooking))
        return displayText.advanceBookingLabel;
    if (categories.includes(FilmCategory.ComingSoon))
        return displayText.comingSoonLabel;
    return undefined;
};
